import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, Form } from 'redux-form';
import { push } from 'react-router-redux';
import { submitContact } from '../../modules/contact';

import './index.scss';
import * as validations from '../../Validation';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import Meta from '../../components/Meta';
import Bubble from '../../components/Bubble';
import RenderSelect from '../../components/Fields/renderSelect';
import ContactForm from '../../components/ContactForm';

const sourceOptions = [
  {
    value: 1,
    label: 'Reed'
  },
  {
    value: 4,
    label: 'Twitter'
  },
  {
    value: 6,
    label: 'Google'
  },
  {
    value: 3,
    label: 'Facebook'
  },
  {
    value: 10,
    label: 'CoursesOnline'
  },
  {
    value: 5,
    label: 'LinkedIn'
  },
  {
    value: 7,
    label: 'Friend referral'
  },
  {
    value: 8,
    label: 'GBS blog'
  },
  {
    value: 9,
    label: 'Other'
  }
];

const renderTextArea = field => (
  <div className={'input-row'}>
    <textarea
      {...field.input}
      placeholder={field.placeholder}
      className={field.meta.touched && field.meta.error && 'error-input'}
    />
    {field.meta.touched && field.meta.error && (
      <span className="error">{field.meta.error}</span>
    )}
  </div>
);

const renderField = field => (
  <div className="input-row">
    <input
      {...field.input}
      type="text"
      placeholder={field.placeholder}
      className={field.meta.touched && field.meta.error && 'error-input'}
    />
    {field.meta.touched && field.meta.error && (
      <span className="error">{field.meta.error}</span>
    )}
  </div>
);

const renderSelect = props => (
  <div>
    <select {...props.input} className={'contactReason'}>
      {props.children}
    </select>
    {props.touched && props.error && <div className="error">{props.error}</div>}
  </div>
);

class Contact extends React.Component {
  state = {
    loading: false
  };

  submit = values => {
    this.setState({
      loading: true
    });
    this.props.dispatch(submitContact(values));
  };

  render() {
    const { error, handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <Page classnames="contact-page">
        <Meta
          type={'website'}
          title="Contact Us | Brighton School of Business Management"
          description="Science Park Square, University of Sussex Campus, Brighton, East Sussex, BN1 9SB, United Kingdom Call: +44 (0)1273 704 463 Email: enquiries@brightonsbm.com"
        />
        <PageHeader>
          <h1>How can we help you?</h1>
          <h2>Choose from the following options</h2>

          {/*<img*/}
          {/*src="/images/circles/topRightBlue.svg"*/}
          {/*height={700}*/}
          {/*style={{ position: 'absolute', top: 0, right: 0, zIndex: -1 }}*/}
          {/*/>*/}
          <div className={'d-none d-lg-inline'}>
            <Bubble
              speed={'17s'}
              right={100}
              widthHeight={500}
              delay={'-8s'}
              backgroundColor={'#0887E0'}
              animations={{
                WebkitAnimation: 'move-up 15s linear infinite',
                MozAnimation: 'move-up 15s linear infinite',
                msAnimation: 'move-up 15s linear infinite',
                OAnimation: 'move-up 15s linear infinite',
                animation: 'move-up 15s linear infinite'
              }}
            />
            <Bubble
              speed={'8s'}
              right={150}
              widthHeight={500}
              delay={'-10s'}
              backgroundColor={'#93CCFD'}
              animations={{
                WebkitAnimation: 'move-up 15s linear infinite',
                MozAnimation: 'move-up 15s linear infinite',
                msAnimation: 'move-up 15s linear infinite',
                OAnimation: 'move-up 15s linear infinite',
                animation: 'move-up 15s linear infinite'
              }}
            />
            <Bubble
              speed={'17s'}
              right={200}
              widthHeight={300}
              delay={'-13s'}
              backgroundColor={'#50DCF6'}
              animations={{
                WebkitAnimation: 'move-up-right 15s linear infinite',
                MozAnimation: 'move-up-right 15s linear infinite',
                msAnimation: 'move-up-right 15s linear infinite',
                OAnimation: 'move-up-right 15s linear infinite',
                animation: 'move-up-right 15s linear infinite'
              }}
            />
            <Bubble
              speed={'17s'}
              right={100}
              widthHeight={200}
              delay={'-3s'}
              backgroundColor={'#4097F8'}
              animations={{
                WebkitAnimation: 'move-up-left 15s linear infinite',
                MozAnimation: 'move-up-left 15s linear infinite',
                msAnimation: 'move-up-left 15s linear infinite',
                OAnimation: 'move-up-left 15s linear infinite',
                animation: 'move-up-left 15s linear infinite'
              }}
            />
          </div>
          <div className={'d-lg-none'}>
            <span className={'homepage topRight blue-15 twoThirds'} />
          </div>
        </PageHeader>

        <span
          className={
            'homepage left blue-15 clockwise-8 topThird d-none d-md-inline'
          }
        />
        <div className={'container'}>
          <div className="row justify-content-center align-items-center">
            <div className={'col-12'}>
              <ContactForm addSpaceBelow={true} removeCustomTitle={true} />
            </div>
          </div>
        </div>

        <div className="col text-center" data-aos="fade-up">
            <a className="cant-find-home-bold" href="/contact">
              Can't find what you are looking for?{' '}
            </a>

            <p
              className="cant-find-home"
              style={{ fontSize: 40, color: 'inherit' }}>
              <span className="cant-find-home-bold">Get in Touch </span>
              Or give us a call on{' '}
              <a href={'tel:01273704463'} style={{ fontWeight: 700 }}>+44 (0)1273 704 463</a>
              
            </p>
          </div>

      </Page>
    );
  }
}

const selector = formValueSelector('contactForm');

const mapStateToProps = state => ({
  contactReason: selector(state, 'contactReason'),
  initialValues: {
    contactReason: '10'
  }
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'contactForm'
  })(Contact)
);
